import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-63ed149a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cv" }
const _hoisted_2 = { class: "cv__elm" }
const _hoisted_3 = { class: "cv__elm-backward" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cv__elm-backward-label" }, "Подтверждение", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_ConfirmationForm = _resolveComponent("ConfirmationForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.device.isMobile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cv__elm-backward-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoBack && _ctx.onGoBack(...args)))
            }, [
              _createVNode(_component_IconArrowLeft, { color: "rgb(49, 49, 50)" })
            ]))
          : _createCommentVNode("", true),
        _hoisted_4
      ]),
      _createVNode(_component_ConfirmationForm)
    ])
  ]))
}